import {
    CHANGE_LANGUAGE,
    SET_ENVS
} from './types';
import Helper from '../helper';

export const setLanguage = (lang) => {
    let langInfo = Helper.getLanguageDetailsByCode(lang);
    if (langInfo) {
        if (langInfo.dir === "ltr") {
            Helper.removeAsset('/static/css/custom_rtl.css', 'css')
            Helper.loadAsset('/static/css/custom_ltr.css', 'css')
        } else {
            Helper.removeAsset('/static/css/custom_ltr.css', 'css')
            Helper.loadAsset('/static/css/custom_rtl.css', 'css')
        }
    }
    return {
        type: CHANGE_LANGUAGE,
        payload: lang
    };
};

export const setEnvironments = (environments) => {
    return {
        type: SET_ENVS,
        environments: environments
    }
}



// WEBPACK FOOTER //
// ./src/actions/index.js